import CryptoLogos from './cryptoLogos';

export default CryptoLogos;
